import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.aboutUs,
    component: () => import('../../pages/operatingCopywriter/aboutUs/list'),
    meta: { title: '关于我们' }
  },
  {
    path: routeNames.privacyAgreement,
    component: () => import('../../pages/operatingCopywriter/privacyAgreement/list'),
    meta: { title: '隐私协议' }
  },
  {
    path: routeNames.communityRules,
    component: () => import('../../pages/operatingCopywriter/communityRules/list'),
    meta: { title: '社区规则' }
  },
  {
    path: routeNames.integralDescription,
    component: () => import('../../pages/operatingCopywriter/integralDescription/list'),
    meta: { title: '积分/成长值/用户等级说明' }
  },
  {
    path: routeNames.talentShowList,
    component: () => import('../../pages/operatingCopywriter/talentShowList/list'),
    meta: { title: '达人榜说明' }
  },
  {
    path: routeNames.rewardRules,
    component: () => import('../../pages/operatingCopywriter/rewardRules/list'),
    meta: { title: '悬赏规则' }
  },
  {
    path: routeNames.shareList,
    component: () => import('../../pages/operatingCopywriter/shareList'),
    meta: { title: '分享卡片' }
  },
  {
    path: routeNames.advertManagement,
    component: () => import('../../pages/operatingCopywriter/advertManagement/list'),
    meta: { title: '帖子广告位' }
  },
  {
    path: routeNames.advertEdit,
    component: () => import('../../pages/operatingCopywriter/advertManagement/edit'),
    meta: { title: '帖子广告位编辑', hideInMenu: true }
  },
  {
    path: routeNames.operationPaperworkQualityTesting,
    component: () => import('../../pages/operatingCopywriter/OperationPaperwork/QualityTesting'),
    meta: { title: '质检公示管理' }
  },
  {
    path: routeNames.operationPaperwork,
    component: () => import('../../pages/operatingCopywriter/OperationPaperwork/QualityTesting/Paperwork'),
    meta: {
      title: '质检公示',
      hideInMenu: true
    }
  },
  {
    path: routeNames.articleSort,
    component: () => import('../../pages/operatingCopywriter/articleSort'),
    meta: { title: '帖子排序设置' }
  }
] as TRoutes[]
